
import {
    getExpiredProductsByStore, 
    searchExpiredProductsForStore,
    exportExpiredProductsByStores,
    filterExpiredProducts,
    putExpiredProduct,
    deleteExpiredProducts,
    deleteExpiredProductsByStore,
    transferExpiredProducts
} from '../services/Api';

const getExpiredProductsByStoreId = async ( storeId, page, limit ) => {
    try {
        const response = await getExpiredProductsByStore( storeId, page, limit );
        return response;
    } catch (err) {
        console.log("err to get products ", err)
        return null;
    }
};

const searchExpiredProductsByStore = async ( storeId, query ) => {
    try {
        const response = await searchExpiredProductsForStore( storeId, query );
        return response;
    } catch (err) {
        console.log("err to get expired products ", err)
        return null;
    }
};

const exportExpiredProducts = async ( storeIds ) => {
    try {
        const response = await exportExpiredProductsByStores( storeIds );
        return response;
    } catch (err) {
        console.log("err to export expired products ", err)
        return null;
    }
};

const filterExpiredProductsByStore = async ( filterData, page, limit ) => {
    try {
        const response = await filterExpiredProducts( filterData, page, limit );
        return response;
    } catch (err) {
        console.log("err to export expired products ", err)
        return null;
    }
};

const updateExpiredProduct = async ( expiredProductData ) => {
    try {
        const response = await putExpiredProduct( expiredProductData );
        return response;
    } catch (err) {
        console.log("err to update expired products ", err)
        return null;
    }
};

const deleteExpiredProductsByIds = async ( productIds ) => {
    try {
        const response = await deleteExpiredProducts( productIds );
        return response;
    } catch (err) {
        console.log("err to delete product ", err)
        return null;
    }
};

const deleteAllExpiredProductsByStoreId = async ( storeId ) => {
    try {
        const response = await deleteExpiredProductsByStore( storeId );
        return response;
    } catch (err) {
        console.log("err to delete product ", err)
        return null;
    }
};

const transferExpiredProductsToAnotherUser = async ( transferData ) => {
    try {
        const response = await transferExpiredProducts( transferData );
        return response;
    } catch (err) {
        console.log("err to to transfer expired products to another user ", err)
        return null;
    }
};

export {
    getExpiredProductsByStoreId,
    searchExpiredProductsByStore,
    exportExpiredProducts,
    filterExpiredProductsByStore,
    updateExpiredProduct,
    deleteExpiredProductsByIds,
    deleteAllExpiredProductsByStoreId,
    transferExpiredProductsToAnotherUser
};